export enum Route {
    Dashboard = "/dashboard",
    Home = "/"
}